import { PropsWithChildren, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMounted } from '@toss/react';
interface SSRSafeTranslationGuardProps extends PropsWithChildren {
  /**
   * 번역이 준비되기 전에 그릴 것. 안 넘기면 아무것도 그리지 않는다.
   * 이 가드는 화면 전체를 감싸는 자리(dashboard-app `_app`, `Play.client`)에도
   * 쓰이므로 그때는 빈 화면이 된다 — 스켈레톤을 넣을 구멍으로 남겨 둔다.
   */
  fallback?: ReactNode;
}
export const SSRSafeTranslationGuard = (props: SSRSafeTranslationGuardProps) => {
  const {
    ready
  } = useTranslation();
  const isMounted = useIsMounted();
  if (isMounted && ready) {
    return props.children;
  }
  return <>{props.fallback}</>;
};